const addCommas = num => {
  if (!num) return '';
  let parts = num.toString().split('.');
  let integerPart = parseInt(parts[0], 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
  return integerPart + decimalPart;
};
const removeNonNumeric = num => {
  if (!num) return '';
  let parts = num.toString().split('.');
  let integerPart = parts[0].replace(/[^0-9]/g, "");
  let decimalPart = parts.length > 1 ? '.' + parts[1].replace(/[^0-9]/g, "") : '';
  return integerPart + decimalPart;
};

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0B";

  const k = 1024; // or 1000 if you prefer SI units
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat(Math.round(bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}

const numberUtils = {
  addCommas,
  removeNonNumeric,
  formatBytes,
};

export default numberUtils;
